import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  makeStyles,
  IconButton
} from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';

import Alert from '../common/alert';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) => ({
  head: {
    '& .MuiTableCell-head': {
      borderBottomColor: 'rgba(0,0,0,0.6)'
    }
  },
  row: {
    verticalAlign: 'top',
  }
  ,
  magazine: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  magazineLogo: {
    flexBasis: '70px',
    flexGrow: 0,
    paddingRight: theme.spacing(1),

    '& img': {
      maxWidth: '100%'
    }
  }
}));

const rowsPerPageOptions = [25, 50, 75, 100];

const TyreAwardsList = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { itemOwnerId } = useParams();

  const { items, noResultsMessage, rows = 50 } = props;

  //TODO: Get real permissions
  const canEdit = true;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if(!items || !items.length) {
    if(noResultsMessage) {
      return (
        <Alert severity="info">{noResultsMessage}</Alert>
      );
    } else {
      return null;
    }
  }

  const visibleRows = items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer>
      <Table>
        <TableHead className={classes.head}>
          <TableRow>
            <TableCell size="small"><Typography variant="overline">{t('tyreAwards:product')}</Typography></TableCell>
            <TableCell size="small"><Typography variant="overline">{t('tyreAwards:magazine')}</Typography></TableCell>
            <TableCell size="small"><Typography variant="overline">{t('tyreAwards:award')}</Typography></TableCell>
            <TableCell size="small"><Typography variant="overline">{t('tyreAwards:country')}</Typography></TableCell>
            <TableCell size="small"><Typography variant="overline">{t('tyreAwards:review')}</Typography></TableCell>
            <TableCell size="small"></TableCell>

          </TableRow>
        </TableHead>
        <TableBody className={classes.body}>
          {visibleRows.map(award => (
            <TableRow key={award.id} classes={{root: classes.row}}>
              <TableCell>{award.product}</TableCell>
              <TableCell width="20%">
                <div className={classes.magazine}>
                  <div className={classes.magazineLogo}>
                    <img src={award.magazineLogo} alt="" />
                  </div>
                  <div className={classes.magazineNumber}>
                    {award.magazineName}<br />
                    {award.magazineNumber}
                  </div>
                </div>
              </TableCell>
              <TableCell>{award.award}</TableCell>
              <TableCell>{award.countryName}</TableCell>
              <TableCell dangerouslySetInnerHTML={{ __html: award.review}}></TableCell>
              <TableCell>
                <IconButton component={Link} to={`/pih/owner/${itemOwnerId}/tyre-award/${award.id}`} aria-label={t('tyreAwards:edit')} title={t('tyreAwards:edit')} color="primary" disabled={!canEdit}>
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={rowsPerPageOptions}
              colSpan={6}
              count={items.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
};

TyreAwardsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  noResultsMessage: PropTypes.string,
  rows: PropTypes.oneOf(rowsPerPageOptions)
};

export default TyreAwardsList;
